import { render, staticRenderFns } from "./FixProductPriceStore.vue?vue&type=template&id=09b15dd2"
import script from "./FixProductPriceStore.vue?vue&type=script&lang=js"
export * from "./FixProductPriceStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports